import InscreenObserver from '@finn-no/inscreen-observer';

export default {
    dependencies: ['$element', 'radio', 'trackingservice'],
    callable(element, radio, trackingservice) {
        const impressionObserver = new InscreenObserver(
            trackSearchResultImpression,
            {
                threshold: 0.75,
                timeout: 1000,
                once: true,
            }
        );
        let searchResultItemEles = [];
        let resultHitCount;
        let uuid;

        setupTracking();

        radio('filter-and-search-changed').subscribe(setupTracking);
        radio('pre-filter-and-search-changed').subscribe(teardownTracking);

        function trackSearchResultImpression(ele) {
            trackingservice.getApi(api => {
                const context = api.prepareContext().context;
                const eventObj = createEventObject(ele, context);
                trackingservice.trackLaterObj(eventObj);
            });
        }

        function createEventObject(ele, context) {
            const { searchTerm, searchPage } = getSearchParameters();
            const {
                finnkode,
                listPosition,
                anyPromoted,
                bapWebStore,
            } = getResultItemAttributes(ele);
            const resultType = getResultType(anyPromoted, bapWebStore);
            return {
                ecType: 'SEARCH',
                ecCategory: 'inscreen',
                eventData: {
                    'search.fullurl': context.fullurl,
                    'search.listposition': listPosition,
                    'search.resultListLayout': context.resultListLayout,
                    'search.searchresultcount': resultHitCount,
                    'search.searchterm': searchTerm,
                    'search.page': searchPage,
                    'search.timestamp': Date.now(),
                    'search.resultType': resultType,
                    'search.uuid': uuid,
                },
                context: {
                    finnkode,
                },
            };
        }

        function getSearchParameters() {
            const url = new URL(document.baseURI);
            return {
                searchTerm: url.searchParams.get('q') || '',
                searchPage: url.searchParams.get('page') || '1',
            };
        }

        function getResultItemAttributes(ele) {
            return {
                finnkode: ele.getAttribute('data-finnkode') || '',
                listPosition: ele.getAttribute('data-listposition') || '',
                anyPromoted: ele.hasAttribute('data-anypromoted'),
                bapWebStore: ele.hasAttribute('data-bapwebstore'),
            };
        }

        function getResultType(anyPromoted, bapWebStore) {
            if (anyPromoted) {
                return 'promoted';
            } else if (bapWebStore) {
                return 'native';
            } else {
                return 'organic';
            }
        }

        function setupTracking() {
            searchResultItemEles = Array.from(
                element.querySelectorAll('[data-search-resultitem]')
            );
            searchResultItemEles.forEach(resultItemEle =>
                impressionObserver.observe(resultItemEle)
            );
            resultHitCount =
                element.getAttribute('data-result-hit-count') || '';
            uuid = element.getAttribute('data-search-uuid') || '';
        }

        function teardownTracking() {
            searchResultItemEles.forEach(resultItemEle => {
                impressionObserver.unobserve(resultItemEle);
            });
            searchResultItemEles = [];
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/searchResultInscreenTracking.js